import { GetListParams, SortInterface } from '@core/interfaces/get-list.interface';
import { NgbDateRange } from '@core/interfaces/date-filter.interface';
import { OffsetPagination } from '@core/interfaces/pagination-params.interface';
import { SalaryCalculationFilter } from '@core/interfaces/salary-calculation.interface';

export class GetSalaryCalculations {
  static readonly type = '[GetSalaryCalculations] Get Salary Calculations';

  constructor(public params: GetListParams<SalaryCalculationFilter>) {}
}

export class SetSalaryCalculationFilter {
  static readonly type = '[SetSalaryCalculationFilter] Set Salary Calculation Filter';

  constructor(public filter: SalaryCalculationFilter) {}
}

export class SetSalaryCalculationDateFilter {
  static readonly type = '[SetSalaryCalculationDateFilter] Set Salary Calculation Date Filter';

  constructor(public dateFilter: NgbDateRange) {}
}

export class SetSalaryCalculationPaginationParams {
  static readonly type = '[SetSalaryCalculationPaginationParams] Set Salary Calculation Pagination Params';

  constructor(public paginationParams: OffsetPagination) {}
}

export class SetSalaryCalculationSort {
  static readonly type = '[SetSalaryCalculationSort] Set Salary Calculation Sort';

  constructor(public sort: SortInterface) {}
}
